<template>
  <v-dialog
    max-width="600px"
    v-model="dialog"
    persistent
    @keydown.enter.prevent="save"
  >
    <v-card>
      <v-card-title/>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete
              v-model="model"
              :items="items"
              :disabled="rules.id === 1"
              item-text="string"
              label="Select Item(s):"
              return-object
              multiple
              small-chips
              deletable-chips
              hide-details
            />
          </v-col>
        </v-row>

        <v-row
          v-if="forms.length"
          dense
        >
          <v-col cols="12">
            <v-simple-table
              dense
              style="max-height: 300px; margin-top: 16px; overflow: auto;"
            >
              <thead>
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-left">State</th>
                  <th class="text-left" style="width: 120px;">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="f in forms" :key="f.string">
                  <td>{{ f.string }}</td>
                  <td>
                    <r-item-state-dropdown
                      :model.sync="f.state"
                      :hide-label="true"
                      style="margin-top: -4px"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="f.amount"
                      hide-details
                      type="number"
                      min="0"
                      dense
                      @keydown.enter.stop
                      style="margin-top: -4px"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import RItemStateDropdown from "@/modules/redactor/views/item/r-item-state-dropdown.vue";

export default {
  name: "r-item-select",
  components: { RItemStateDropdown },

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: [],
    forms: [],
    rules: ViewRules.READONLY,
    items: [],
    prefillByKey: null,
  }),

  computed: {
    empty() {
      return this.forms.length === 0;
    }
  },

  watch: {
    model: {
      handler() {
        this.syncForms();
      }
    }
  },

  methods: {
    show(rules, input) {
      this.dialog = true;
      this.rules = rules;

      const src = Array.isArray(input) ? input : (input ? [input] : []);
      this.prefillByKey = new Map();
      src.forEach(v => {
        if (v instanceof ItemKey && v.string) {
          this.prefillByKey.set(v.string, v);
        }
      });

      this.model = this.toItemArray(input);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    syncForms() {
      const byKeySelected = new Set(this.model.map(k => k.string));
      const existing = new Map(this.forms.map(f => [f.string, f]));

      this.model.forEach(sel => {
        if (!existing.has(sel.string)) {
          const clone = sel.clone ? sel.clone() : Object.assign(new ItemKey(), sel);
          const pre = this.prefillByKey?.get(sel.string);

          if (pre) {
            if (typeof pre.amount === 'number') clone.amount = pre.amount;
            if (pre.state) clone.state = pre.state.clone ? pre.state.clone() : pre.state;
          } else if (typeof clone.amount !== 'number') {
            clone.amount = 0;
          }

          this.forms.push(clone);
        }
      });

      this.forms = this.forms.filter(f => byKeySelected.has(f.string));
    },

    toItemArray(input) {
      const asArray = Array.isArray(input) ? input : (input ? [input] : []);
      const all = this.items;
      const byKey = new Map(all.map(k => [k.string, k]));

      const result = [];

      asArray.forEach(i => {
        if (i instanceof ItemKey) {
          const found = i.string ? byKey.get(i.string) : null;
          if (found) result.push(found);
        }
      });

      return result;
    },

    save() {
      const list = Array.isArray(this.forms) ? this.forms : [];
      const isValid =
        list.length > 0 &&
        list.every(i => i && typeof i.valid === 'function' && i.valid());

      if (!isValid) {
        this.$alert("Invalid config!");
        return;
      }

      const payload = list.map(i => (i.clone ? i.clone() : i));
      this.resolve(payload);
      this.discard();
    },

    cancel() {
      this.reject();
      this.discard();
    },

    discard() {
      this.dialog = false;
      this.model = [];
      this.forms = [];
      this.prefillByKey = null;
    }
  },

  created() {
    this.items = RedactorUtils.getItems().map(v => v.key);
  }
};
</script>
